import Vue from 'vue';
import Router from 'vue-router';
import Builder from '../views/Builder';
import Home from '../views/Home';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/:divisionName',
      name: 'builder',
      component: Builder,
      props: true,
    },
  ],
});
